export default {
    altAsset: "altAsset",
    assetAttribute: "assetAttribute",
    assetCore: "assetCore",
    audit: "audit",
    auditAsset: "auditAsset",
    assetAuditor: "assetAuditor",
    auditAssignment: "auditAssignment",
    auditImage: "auditImage",
    auditLocation: "auditLocation",
    branch: "branch",
    location: "location",
    organisation: "organisation",
    note: "note",
    reduxState: "reduxState",
    unexpectedAsset: "unexpectedAsset",
    typesList: "typesList",
    searchCache: "searchCache",
    pendingSubmission: "pendingSubmission",
};
